var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicDashboardStudyMaterials1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    style: {
      baselineShift: 0,
      clipRule: "nonzero",
      color: "rgb(61, 61, 61)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      cursor: "auto",
      direction: "ltr",
      display: "block",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      font: "400 16px / 18.4px Lato, sans-serif",
      imageRendering: "auto",
      letterSpacing: "normal",
      marker: "none",
      overflow: "hidden",
      paintOrder: "normal",
      pointerEvents: "auto",
      shapeRendering: "auto",
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      textAnchor: "start",
      textDecoration: "none solid rgb(61, 61, 61)",
      textRendering: "auto",
      visibility: "visible",
      wordSpacing: 0,
      writingMode: "horizontal-tb"
    },
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M382.5 1016.1L198.7 784.798C189.8 773.598 188.3 757.098 194.8 743.998L432 270.598C438.5 257.698 449.8 249.198 462.6 247.698L1005.3 183.798C1016.6 182.498 1027.8 186.698 1036.2 195.598L1400.2 578.098C1409.3 587.598 1412.4 602.598 1408.1 615.898L1278.6 1016.1H382.5V1016.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M382.5 1016.1L198.7 784.798C189.8 773.598 188.3 757.098 194.8 743.998L432 270.598C438.5 257.698 449.8 249.198 462.6 247.698L1005.3 183.798C1016.6 182.498 1027.8 186.698 1036.2 195.598L1400.2 578.098C1409.3 587.598 1412.4 602.598 1408.1 615.898L1278.6 1016.1H382.5V1016.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.1 835.501C627.1 835.501 621.7 831.901 618.7 828.801C612.1 821.901 612.3 812.401 612.5 810.001V733.801H627.5V810.701V811.101C627.4 812.401 627.6 816.401 629.7 818.601C631.2 820.101 633.7 820.801 637.2 820.601L638 835.601C637.3 835.501 636.7 835.501 636.1 835.501Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M636.1 835.501C627.1 835.501 621.7 831.901 618.7 828.801C612.1 821.901 612.3 812.401 612.5 810.001V733.801H627.5V810.701V811.101C627.4 812.401 627.6 816.401 629.7 818.601C631.2 820.101 633.7 820.801 637.2 820.601L638 835.601C637.3 835.501 636.7 835.501 636.1 835.501Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.6 835.7C630.6 835.7 625.2 832.1 622.2 829C615.6 822.1 615.8 812.6 616 810.2V734H631V810.9V811.3C630.9 812.6 631.1 816.6 633.2 818.8C634.7 820.3 647.2 821 650.7 820.8L651.5 835.8C650.8 835.7 640.2 835.7 639.6 835.7Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M639.6 835.7C630.6 835.7 625.2 832.1 622.2 829C615.6 822.1 615.8 812.6 616 810.2V734H631V810.9V811.3C630.9 812.6 631.1 816.6 633.2 818.8C634.7 820.3 647.2 821 650.7 820.8L651.5 835.8C650.8 835.7 640.2 835.7 639.6 835.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 660H687V734H578C573.6 734 570 730.4 570 726V668C570 663.6 573.6 660 578 660Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M586 726V668C586 663.6 589.6 660 594 660H578C573.6 660 570 663.6 570 668V726C570 730.4 573.6 734 578 734H594C589.6 734 586 730.4 586 726Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.3 828H789V850H606.3C601.7 850 598 846.3 598 841.7V836.3C598 831.7 601.7 828 606.3 828Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.9 842.901V835.101C699 831.001 702.5 827.801 706.5 828.001H606.6C601.9 828.001 598 831.601 598 836.001V842.001C598 846.401 601.8 850.001 606.6 850.001H706.5C702.4 850.101 699 847.001 698.9 842.901Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 850H653V856H747V850Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 856H685V865H715V856Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M696 856H685V865H696V856Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 865H691V987H709V865Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M709 865H691V987H709V865Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M698.2 865H691V987H698.2V865Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M715 856H685V858H715V856Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M693 850H653V856H693V850Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.5 984.699H641.8C639.7 984.699 638 986.399 638 988.499V1002.3H646.7V993.399H695.3V1004.1H704V993.399H752.6V1002.3H761.3V988.499C761.3 986.399 759.6 984.699 757.5 984.699H753.5Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.3 1013C647.547 1013 651.8 1008.75 651.8 1003.5C651.8 998.253 647.547 994 642.3 994C637.053 994 632.8 998.253 632.8 1003.5C632.8 1008.75 637.053 1013 642.3 1013Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M642.3 1007.7C644.619 1007.7 646.5 1005.82 646.5 1003.5C646.5 1001.18 644.619 999.301 642.3 999.301C639.98 999.301 638.1 1001.18 638.1 1003.5C638.1 1005.82 639.98 1007.7 642.3 1007.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.8 1013C705.047 1013 709.3 1008.75 709.3 1003.5C709.3 998.253 705.047 994 699.8 994C694.553 994 690.3 998.253 690.3 1003.5C690.3 1008.75 694.553 1013 699.8 1013Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M699.8 1007.7C702.119 1007.7 704 1005.82 704 1003.5C704 1001.18 702.119 999.301 699.8 999.301C697.48 999.301 695.6 1001.18 695.6 1003.5C695.6 1005.82 697.48 1007.7 699.8 1007.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.3 1013C762.547 1013 766.8 1008.75 766.8 1003.5C766.8 998.253 762.547 994 757.3 994C752.053 994 747.8 998.253 747.8 1003.5C747.8 1008.75 752.053 1013 757.3 1013Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M757.3 1007.7C759.619 1007.7 761.5 1005.82 761.5 1003.5C761.5 1001.18 759.619 999.301 757.3 999.301C754.98 999.301 753.1 1001.18 753.1 1003.5C753.1 1005.82 754.98 1007.7 757.3 1007.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711 889H689V971H711V889Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M696 889H689V971H696V889Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852 774H831.5V1013.4H852V774Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M852 843.5H842V1013.4H852V843.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.8 388.5H932.8V1012.2H1259.7V430.4L1219.8 388.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1219.8 388.5H932.8V1012.2H1259.7V430.4L1219.8 388.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171 401.699H945.9V521.599H1171V401.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171 666.699H945.9V786.599H1171V666.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171 534.199H945.9V654.099H1171V534.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1024 402H946V521H1024V402Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1024 535H946V654H1024V535Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1024 667H946V786H1024V667Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046 409H959V521H1046V409Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1046 409H959V521H1046V409Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046 409H983.8V521H1046V409Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.8 435.602H963.4V483.902H979.8V435.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.9 436.499V482.999H964.3V436.499H978.9ZM980.7 434.699H962.5V484.699H980.7V434.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M978.9 436.499V482.999H964.3V436.499H978.9ZM980.7 434.699H962.5V484.699H980.7V434.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.9 440.898H964.3V449.298H978.9V440.898Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.9 473.801H964.3V476.901H978.9V473.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M971.6 509.202C968.1 509.202 965.3 506.402 965.3 502.902C965.3 499.402 968.1 496.602 971.6 496.602C975.1 496.602 977.9 499.402 977.9 502.902C977.9 506.402 975.1 509.202 971.6 509.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M971.6 497.499C974.6 497.499 977 499.899 977 502.899C977 505.899 974.6 508.299 971.6 508.299C968.6 508.299 966.2 505.899 966.2 502.899C966.2 499.899 968.6 497.499 971.6 497.499ZM971.6 495.699C967.6 495.699 964.4 498.899 964.4 502.899C964.4 506.899 967.6 510.099 971.6 510.099C975.6 510.099 978.8 506.899 978.8 502.899C978.8 498.899 975.6 495.699 971.6 495.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 409H993V521H1080V409Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1080 409H1017.8V521H1080V409Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.8 435.602H997.4V483.902H1013.8V435.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.9 436.499V482.999H998.3V436.499H1012.9ZM1014.7 434.699H996.5V484.699H1014.7V434.699Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.9 440.898H998.3V449.298H1012.9V440.898Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.9 473.801H998.3V476.901H1012.9V473.801Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1005.6 509.202C1002.1 509.202 999.3 506.402 999.3 502.902C999.3 499.402 1002.1 496.602 1005.6 496.602C1009.1 496.602 1011.9 499.402 1011.9 502.902C1011.9 506.402 1009.1 509.202 1005.6 509.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1005.6 497.499C1008.6 497.499 1011 499.899 1011 502.899C1011 505.899 1008.6 508.299 1005.6 508.299C1002.6 508.299 1000.2 505.899 1000.2 502.899C1000.2 499.899 1002.6 497.499 1005.6 497.499ZM1005.6 495.699C1001.6 495.699 998.4 498.899 998.4 502.899C998.4 506.899 1001.6 510.099 1005.6 510.099C1009.6 510.099 1012.8 506.899 1012.8 502.899C1012.8 498.899 1009.6 495.699 1005.6 495.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114 409H1027V521H1114V409Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1114 409H1027V521H1114V409Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1114 409H1051.8V521H1114V409Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.8 435.602H1031.4V483.902H1047.8V435.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.9 436.499V482.999H1032.3V436.499H1046.9ZM1048.7 434.699H1030.5V484.699H1048.7V434.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046.9 436.499V482.999H1032.3V436.499H1046.9ZM1048.7 434.699H1030.5V484.699H1048.7V434.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.9 440.898H1032.3V449.298H1046.9V440.898Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.9 473.801H1032.3V476.901H1046.9V473.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1039.6 509.202C1036.1 509.202 1033.3 506.402 1033.3 502.902C1033.3 499.402 1036.1 496.602 1039.6 496.602C1043.1 496.602 1045.9 499.402 1045.9 502.902C1045.9 506.402 1043.1 509.202 1039.6 509.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1039.6 497.499C1042.6 497.499 1045 499.899 1045 502.899C1045 505.899 1042.6 508.299 1039.6 508.299C1036.6 508.299 1034.2 505.899 1034.2 502.899C1034.2 499.899 1036.6 497.499 1039.6 497.499ZM1039.6 495.699C1035.6 495.699 1032.4 498.899 1032.4 502.899C1032.4 506.899 1035.6 510.099 1039.6 510.099C1043.6 510.099 1046.8 506.899 1046.8 502.899C1046.8 498.899 1043.6 495.699 1039.6 495.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.3 515.002L1075.2 514.002L1108.4 409.102H1159.7L1148.3 515.002Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1148.3 515.002L1075.2 514.002L1108.4 409.102H1159.7L1148.3 515.002Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.1 521.4H1099.1L1131.5 416.4L1158 415.5L1138.1 521.4Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1138.1 521.4H1099.1L1131.5 416.4L1158 415.5L1138.1 521.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.1 521.4L1075.2 514L1108.3 409L1132.2 416.5L1099.1 521.4Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.62 435.355L1090.37 480.98L1105.83 485.811L1120.09 440.186L1104.62 435.355Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.2 436.501L1119 440.801L1105.3 484.701L1091.5 480.401L1105.2 436.501ZM1104.1 434.301L1103.6 436.001L1089.9 479.901L1089.4 481.601L1091.1 482.101L1104.9 486.401L1106.6 486.901L1107.1 485.201L1120.8 441.301L1121.3 439.601L1119.6 439.101L1105.8 434.801L1104.1 434.301Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.19 436.401L1102.71 444.324L1116.56 448.645L1119.03 440.722L1105.19 436.401Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.25 471.76L1093.33 474.719L1107.17 479.043L1108.09 476.084L1094.25 471.76Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1092.5 507.601C1091.9 507.601 1091.2 507.501 1090.6 507.301C1087.3 506.301 1085.5 502.801 1086.5 499.501C1087.5 496.201 1091 494.401 1094.3 495.401C1095.9 495.901 1097.2 497.001 1098 498.501C1099.6 501.601 1098.4 505.301 1095.4 506.901C1094.5 507.401 1093.5 507.701 1092.5 507.601Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1092.5 495.999C1093 495.999 1093.6 496.099 1094.1 496.199C1096.9 497.099 1098.5 500.099 1097.6 502.899C1096.9 505.099 1094.8 506.599 1092.5 506.699C1092 506.699 1091.4 506.599 1090.9 506.499C1088.1 505.599 1086.5 502.599 1087.4 499.799C1088.1 497.499 1090.2 495.999 1092.5 495.999ZM1092.5 494.199C1088.6 494.199 1085.4 497.399 1085.4 501.299C1085.4 504.399 1087.4 507.199 1090.4 508.099C1091.1 508.299 1091.8 508.399 1092.5 508.399C1096.4 508.399 1099.6 505.199 1099.6 501.299C1099.6 498.199 1097.6 495.399 1094.6 494.499C1094 494.399 1093.2 494.299 1092.5 494.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.6 411.398H1116L1132.2 416.498L1159 415.498L1159.6 411.398Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171 409H1133V521H1171V409Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1171 409H1133V521H1171V409Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171 409H1157.8V521H1171V409Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.8 435.602H1137.4V483.902H1153.8V435.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.9 436.499V482.999H1138.3V436.499H1152.9ZM1154.7 434.699H1136.5V484.699H1154.7V434.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1152.9 436.499V482.999H1138.3V436.499H1152.9ZM1154.7 434.699H1136.5V484.699H1154.7V434.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.9 440.898H1138.3V449.298H1152.9V440.898Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.9 473.801H1138.3V476.901H1152.9V473.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1145.6 509.202C1142.1 509.202 1139.3 506.402 1139.3 502.902C1139.3 499.402 1142.1 496.602 1145.6 496.602C1149.1 496.602 1151.9 499.402 1151.9 502.902C1151.9 506.402 1149.1 509.202 1145.6 509.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1145.6 497.499C1148.6 497.499 1151 499.899 1151 502.899C1151 505.899 1148.6 508.299 1145.6 508.299C1142.6 508.299 1140.2 505.899 1140.2 502.899C1140.2 499.899 1142.6 497.499 1145.6 497.499ZM1145.6 495.699C1141.6 495.699 1138.4 498.899 1138.4 502.899C1138.4 506.899 1141.6 510.099 1145.6 510.099C1149.6 510.099 1152.8 506.899 1152.8 502.899C1152.8 498.899 1149.6 495.699 1145.6 495.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139 675H1101V787H1139V675Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1139 675H1101V787H1139V675Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1139 675H1125.8V787H1139V675Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.8 701.602H1105.4V749.902H1121.8V701.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.9 702.499V748.999H1106.3V702.499H1120.9ZM1122.7 700.699H1104.5V750.699H1122.7V700.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1120.9 702.499V748.999H1106.3V702.499H1120.9ZM1122.7 700.699H1104.5V750.699H1122.7V700.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.9 706.898H1106.3V715.298H1120.9V706.898Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.9 739.801H1106.3V742.901H1120.9V739.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1113.6 775.202C1110.1 775.202 1107.3 772.402 1107.3 768.902C1107.3 765.402 1110.1 762.602 1113.6 762.602C1117.1 762.602 1119.9 765.402 1119.9 768.902C1119.9 772.402 1117.1 775.202 1113.6 775.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1113.6 763.499C1116.6 763.499 1119 765.899 1119 768.899C1119 771.899 1116.6 774.299 1113.6 774.299C1110.6 774.299 1108.2 771.899 1108.2 768.899C1108.2 765.899 1110.6 763.499 1113.6 763.499ZM1113.6 761.699C1109.6 761.699 1106.4 764.899 1106.4 768.899C1106.4 772.899 1109.6 776.099 1113.6 776.099C1117.6 776.099 1120.8 772.899 1120.8 768.899C1120.8 764.899 1117.6 761.699 1113.6 761.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171 675H1133V787H1171V675Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171 675H1157.8V787H1171V675Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.8 701.602H1137.4V749.902H1153.8V701.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.9 702.499V748.999H1138.3V702.499H1152.9ZM1154.7 700.699H1136.5V750.699H1154.7V700.699Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.9 706.898H1138.3V715.298H1152.9V706.898Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.9 739.801H1138.3V742.901H1152.9V739.801Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1145.6 775.202C1142.1 775.202 1139.3 772.402 1139.3 768.902C1139.3 765.402 1142.1 762.602 1145.6 762.602C1149.1 762.602 1151.9 765.402 1151.9 768.902C1151.9 772.402 1149.1 775.202 1145.6 775.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1145.6 763.499C1148.6 763.499 1151 765.899 1151 768.899C1151 771.899 1148.6 774.299 1145.6 774.299C1142.6 774.299 1140.2 771.899 1140.2 768.899C1140.2 765.899 1142.6 763.499 1145.6 763.499ZM1145.6 761.699C1141.6 761.699 1138.4 764.899 1138.4 768.899C1138.4 772.899 1141.6 776.099 1145.6 776.099C1149.6 776.099 1152.8 772.899 1152.8 768.899C1152.8 764.899 1149.6 761.699 1145.6 761.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.6 635.602H1049V653.002H1099.6V635.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.7 634.602H968.8V654.202H1047.7V634.602Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1047.7 634.602H968.8V654.202H1047.7V634.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.2 638.301H977.3V650.401H1019.2V638.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.4 638.999V649.799H978V638.999H1018.4ZM1020 637.699H976.5V651.099H1020V637.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.6 639H979.3V649.8H986.6V639Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.2 639H1010.5V649.8H1013.2V639Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.6 648.501C1031.3 648.501 1029.5 646.701 1029.5 644.401C1029.5 642.101 1031.3 640.301 1033.6 640.301C1035.9 640.301 1037.7 642.101 1037.7 644.401C1037.7 646.701 1035.9 648.501 1033.6 648.501Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1033.6 640.799C1035.6 640.799 1037.1 642.399 1037.1 644.399C1037.1 646.399 1035.5 647.899 1033.5 647.899C1031.5 647.899 1030 646.299 1030 644.299C1030.1 642.399 1031.7 640.799 1033.6 640.799ZM1033.6 639.699C1031 639.699 1028.9 641.799 1028.9 644.399C1028.9 646.999 1031 649.099 1033.6 649.099C1036.2 649.099 1038.3 646.999 1038.3 644.399C1038.3 641.799 1036.2 639.699 1033.6 639.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.8 652.802H1099.1H1049V636.002H1099.5H1100.8H1102.3V634.602H1047.5V654.202H1102.3V652.802H1100.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 636.898H1049V637.698H1099.6V636.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 638.5H1049V639.3H1099.6V638.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 640H1049V640.8H1099.6V640Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 641.602H1049V642.402H1099.6V641.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 643.102H1049V643.902H1099.6V643.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 644.699H1049V645.499H1099.6V644.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 646.199H1049V646.999H1099.6V646.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 647.801H1049V648.601H1099.6V647.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 649.398H1049V650.198H1099.6V649.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1099.6 650.898H1049V651.698H1099.6V650.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.1 597H1045.5V614.4H1096.1V597Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.2 596H965.3V615.6H1044.2V596Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1044.2 596H965.3V615.6H1044.2V596Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.6 599.801H973.7V611.901H1015.6V599.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.9 600.402V611.202H974.5V600.402H1014.9ZM1016.4 599.102H973V612.502H1016.5L1016.4 599.102Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.1 600.398H975.8V611.198H983.1V600.398Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.6 600.398H1006.9V611.198H1009.6V600.398Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.1 609.899C1027.8 609.899 1026 608.099 1026 605.799C1026 603.499 1027.8 601.699 1030.1 601.699C1032.4 601.699 1034.2 603.499 1034.2 605.799C1034.2 608.099 1032.4 609.899 1030.1 609.899Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1030.1 602.202C1032.1 602.202 1033.7 603.802 1033.7 605.702C1033.7 607.602 1032.1 609.302 1030.2 609.302C1028.3 609.302 1026.6 607.702 1026.6 605.802C1026.5 603.802 1028.1 602.202 1030.1 602.202ZM1030.1 601.102C1027.5 601.102 1025.4 603.202 1025.4 605.802C1025.4 608.402 1027.5 610.502 1030.1 610.502C1032.7 610.502 1034.8 608.402 1034.8 605.802C1034.8 603.202 1032.7 601.102 1030.1 601.102Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.2 614.2H1095.5H1045.5V597.4H1096H1097.2H1098.7V596H1043.9V615.6H1098.7V614.2H1097.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 598.301H1045.5V599.101H1096.1V598.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 599.898H1045.5V600.698H1096.1V599.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 601.5H1045.5V602.3H1096.1V601.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 603H1045.5V603.8H1096.1V603Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 604.602H1045.5V605.402H1096.1V604.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 606.102H1045.5V606.902H1096.1V606.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 607.699H1045.5V608.499H1096.1V607.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 609.199H1045.5V609.999H1096.1V609.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 610.801H1045.5V611.601H1096.1V610.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1096.1 612.301H1045.5V613.101H1096.1V612.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.4 616.398H1057.8V633.798H1108.4V616.398Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.5 615.301H977.6V634.901H1056.5V615.301Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028 619.102H986.1V631.202H1028V619.102Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.2 619.8V630.6H986.8V619.8H1027.2ZM1028.8 618.5H985.3V631.9H1028.8V618.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.4 619.801H988.1V630.601H995.4V619.801Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022 619.801H1019.3V630.601H1022V619.801Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1042.4 629.302C1040.1 629.302 1038.3 627.502 1038.3 625.202C1038.3 622.902 1040.1 621.102 1042.4 621.102C1044.7 621.102 1046.5 622.902 1046.5 625.202C1046.5 627.402 1044.7 629.302 1042.4 629.302Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1042.4 621.598C1044.4 621.598 1046 623.198 1046 625.098C1046 627.098 1044.4 628.698 1042.5 628.698C1040.6 628.698 1038.9 627.098 1038.9 625.198C1038.9 623.198 1040.5 621.598 1042.4 621.598ZM1042.4 620.398C1039.8 620.398 1037.7 622.498 1037.7 625.098C1037.7 627.698 1039.8 629.798 1042.4 629.798C1045 629.798 1047.1 627.698 1047.1 625.098C1047.1 622.498 1045 620.398 1042.4 620.398Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.5 633.601H1107.9H1057.8V616.701H1108.3H1109.5H1111.1V615.301H1056.3V634.901H1111.1V633.601H1109.5Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1109.5 633.601H1107.9H1057.8V616.701H1108.3H1109.5H1111.1V615.301H1056.3V634.901H1111.1V633.601H1109.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 617.699H1057.8V618.499H1108.4V617.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 619.199H1057.8V619.999H1108.4V619.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 620.801H1057.8V621.601H1108.4V620.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 622.301H1057.8V623.101H1108.4V622.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 623.898H1057.8V624.698H1108.4V623.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 625.5H1057.8V626.3H1108.4V625.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 627H1057.8V627.8H1108.4V627Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 628.602H1057.8V629.402H1108.4V628.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 630.102H1057.8V630.902H1108.4V630.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1108.4 631.699H1057.8V632.499H1108.4V631.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.6 707H958.9V787H1088.6V707Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1088.6 707H958.9V787H1088.6V707Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 783.398H1033.2V786.398H1090.2V783.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 778.301H1033.2V781.301H1090.2V778.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 773.199H1033.2V776.199H1090.2V773.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 768.102H1033.2V771.102H1090.2V768.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 763H1033.2V766H1090.2V763Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 757.898H1033.2V760.898H1090.2V757.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 752.801H1033.2V755.801H1090.2V752.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 747.699H1033.2V750.699H1090.2V747.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 742.699H1033.2V745.699H1090.2V742.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 737.602H1033.2V740.602H1090.2V737.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 732.5H1033.2V735.5H1090.2V732.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 727.398H1033.2V730.398H1090.2V727.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 722.301H1033.2V725.301H1090.2V722.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 717.199H1033.2V720.199H1090.2V717.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 712.102H1033.2V715.102H1090.2V712.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1090.2 707H1033.2V710H1090.2V707Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 783.398H956.9V786.398H1040.8V783.398Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 778.301H956.9V781.301H1040.8V778.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 773.199H956.9V776.199H1040.8V773.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 768.102H956.9V771.102H1040.8V768.102Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 763H956.9V766H1040.8V763Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 757.898H956.9V760.898H1040.8V757.898Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 752.801H956.9V755.801H1040.8V752.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 747.699H956.9V750.699H1040.8V747.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 742.699H956.9V745.699H1040.8V742.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 737.602H956.9V740.602H1040.8V737.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 732.5H956.9V735.5H1040.8V732.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 727.398H956.9V730.398H1040.8V727.398Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 722.301H956.9V725.301H1040.8V722.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 717.199H956.9V720.199H1040.8V717.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 712.102H956.9V715.102H1040.8V712.102Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 707H956.9V710H1040.8V707Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055 986H945V797H1055V986ZM947 984H1053V799H947V984Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171 986H1062V797H1171V986ZM1064 984H1169V799H1064V984Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077 864H1071V895H1077V864Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046 864H1040V895H1046V864Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.7 619.999C1124.1 616.199 1120.6 607.299 1120.3 599.999C1120.2 592.499 1123.8 585.399 1129.9 580.999C1136.2 576.699 1144.4 576.599 1150.7 580.799C1157.2 585.199 1161 592.599 1160.7 600.399C1160.2 608.199 1156.3 615.299 1150 619.899",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1130.3 620.202C1117.6 587.002 1138.9 577.702 1139.1 577.602L1139.4 578.402C1139.2 578.502 1118.7 587.502 1131 619.902L1130.3 620.202Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1148.5 620.202C1161.2 587.002 1139.9 577.702 1139.7 577.602L1139.4 578.402C1139.6 578.502 1160.1 587.502 1147.8 619.902L1148.5 620.202Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.3 598.402C1122.3 598.602 1121.2 598.602 1120 598.502C1118.8 598.402 1117.7 598.202 1117.7 598.002C1117.7 597.802 1118.8 597.802 1120 597.902C1121.2 598.002 1122.3 598.202 1122.3 598.402Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.6 591.901C1122.5 592.101 1121.6 591.801 1120.6 591.301C1119.6 590.801 1118.8 590.301 1118.8 590.201C1118.8 590.101 1119.8 590.301 1120.8 590.801C1121.8 591.301 1122.7 591.701 1122.6 591.901Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126 587C1125.9 587.1 1124.9 586.7 1123.8 585.8C1122.7 584.9 1122.1 584 1122.2 583.9C1122.3 583.8 1123.2 584.5 1124.2 585.3C1125.2 586.1 1126.1 586.9 1126 587Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.4 582.4C1129.2 582.5 1128.8 581.7 1128.3 580.7C1127.8 579.7 1127.6 578.8 1127.8 578.7C1128 578.6 1128.4 579.4 1128.9 580.4C1129.4 581.4 1129.5 582.4 1129.4 582.4Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.7 579.199C1134.5 579.299 1134 578.499 1133.7 577.299C1133.4 576.099 1133.3 575.199 1133.5 575.199C1133.7 575.199 1134 575.999 1134.3 577.099C1134.6 578.199 1134.8 579.099 1134.7 579.199Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.5 575.5C1143.7 575.6 1143.6 576.3 1143.3 577C1143 577.7 1142.7 578.4 1142.5 578.3C1142.3 578.2 1142.4 577.5 1142.7 576.7C1143 575.9 1143.4 575.5 1143.5 575.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.1 578.3C1150.2 578.4 1149.8 579 1149.2 579.6C1148.6 580.2 1148 580.6 1147.8 580.4C1147.6 580.2 1148.1 579.7 1148.7 579.1C1149.3 578.5 1150 578.2 1150.1 578.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.9 582.102C1156 582.202 1155.5 582.802 1154.7 583.302C1153.9 583.802 1153.3 584.102 1153.2 583.902C1153.1 583.702 1153.6 583.202 1154.3 582.702C1155 582.202 1155.8 581.902 1155.9 582.102Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 587.6C1160.1 587.8 1159.3 588.3 1158.2 588.7C1157.1 589.1 1156.2 589.4 1156.1 589.2C1156 589 1156.9 588.5 1157.9 588.1C1158.9 587.7 1159.9 587.5 1160 587.6Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.6 593.701C1161.6 593.901 1160.8 594.101 1159.8 594.201C1158.8 594.301 1157.9 594.301 1157.9 594.101C1157.9 593.901 1158.7 593.701 1159.7 593.601C1160.7 593.501 1161.6 593.501 1161.6 593.701Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.4 601.199C1162.3 601.399 1161.4 601.099 1160.4 600.699C1159.4 600.299 1158.6 599.799 1158.7 599.599C1158.8 599.399 1159.6 599.699 1160.7 600.099C1161.8 600.499 1162.5 600.999 1162.4 601.199Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.7 607.601C1161.6 607.801 1160.5 607.502 1159.4 606.702C1158.3 605.902 1157.6 605.002 1157.7 604.902C1157.8 604.802 1158.7 605.402 1159.8 606.202C1160.9 607.002 1161.8 607.401 1161.7 607.601Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.4 613.401C1158.3 613.501 1157.4 613.001 1156.6 612.101C1155.8 611.201 1155.3 610.301 1155.4 610.201C1155.5 610.101 1156.2 610.801 1157 611.701C1157.8 612.601 1158.5 613.301 1158.4 613.401Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.7 614.101C1126.8 614.301 1125.9 614.901 1124.6 615.501C1123.3 616.101 1122.3 616.501 1122.2 616.401C1122.1 616.301 1123 615.601 1124.3 615.001C1125.6 614.401 1126.6 614.001 1126.7 614.101Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.8 608.8C1123.9 609 1123.1 609.501 1122.1 609.901C1121.1 610.301 1120.3 610.601 1120.2 610.401C1120.1 610.201 1120.9 609.8 1121.9 609.3C1122.9 608.8 1123.7 608.7 1123.8 608.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.6 604.201C1121.6 604.401 1120.7 604.601 1119.5 604.801C1118.3 605.001 1117.4 605.001 1117.4 604.801C1117.4 604.601 1118.3 604.401 1119.4 604.201C1120.5 604.001 1121.6 604.001 1121.6 604.201Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.6 601.601C1128.7 601.801 1127.8 602.201 1126.6 602.301C1125.4 602.401 1124.4 602.201 1124.5 602.101C1124.6 602.001 1125.4 601.901 1126.6 601.701C1127.8 601.501 1128.6 601.401 1128.6 601.601Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.4 595.802C1134.4 596.002 1133.7 596.302 1132.8 596.402C1131.9 596.502 1131.1 596.302 1131.1 596.102C1131.1 595.902 1131.9 595.902 1132.8 595.802C1133.7 595.702 1134.4 595.702 1134.4 595.802Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.5 591.2C1135.4 591.4 1134.7 591.2 1133.8 590.9C1132.9 590.6 1132.2 590.2 1132.3 590.1C1132.4 590 1133.1 590.1 1134 590.4C1134.9 590.7 1135.6 591 1135.5 591.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 586.501C1137.6 586.601 1137 586.301 1136.7 585.601C1136.4 584.901 1136.3 584.301 1136.4 584.301C1136.5 584.301 1136.9 584.701 1137.2 585.301C1137.5 585.901 1137.8 586.401 1137.7 586.501Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.1 605.701C1135.1 605.901 1134.5 606.201 1133.6 606.401C1133.2 606.501 1132.8 606.601 1132.4 606.601L1132.3 606.201C1132.5 606.201 1132.7 606.201 1132.7 606.201C1132.7 606.201 1132.6 606.401 1132.5 606.501L1132.4 606.101C1132.8 605.901 1133.2 605.801 1133.6 605.701C1134.3 605.501 1135.1 605.501 1135.1 605.701Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.3 613.8C1136.4 614 1135.5 614.501 1134.4 614.901C1133.3 615.301 1132.3 615.601 1132.3 615.401C1132.3 615.201 1133.1 614.8 1134.2 614.3C1135.3 613.8 1136.2 613.7 1136.3 613.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.7 610.202C1129.8 610.402 1129.2 610.702 1128.4 611.002C1127.6 611.302 1127 611.302 1126.9 611.202C1126.8 611.102 1127.4 610.702 1128.2 610.402C1129 610.102 1129.7 610.002 1129.7 610.202Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.2 593.5C1130.2 593.7 1129.2 593.6 1128 593.2C1126.8 592.8 1126 592.2 1126.1 592.1C1126.2 592 1127.1 592.2 1128.2 592.6C1129.3 593 1130.3 593.4 1130.2 593.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.1 591.699C1146.2 591.799 1145.6 592.399 1144.9 592.899C1144.2 593.399 1143.4 593.699 1143.3 593.599C1143.2 593.499 1143.8 592.899 1144.5 592.399C1145.2 591.899 1146 591.599 1146.1 591.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147 600.002C1147 600.202 1146.4 600.402 1145.7 600.602C1145 600.802 1144.3 600.802 1144.3 600.602C1144.3 600.402 1144.9 600.202 1145.6 600.002C1146.3 599.802 1146.9 599.802 1147 600.002Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148 609.199C1147.9 609.399 1147.1 609.099 1146.1 608.699C1145.1 608.299 1144.4 607.799 1144.5 607.599C1144.6 607.399 1145.4 607.699 1146.4 608.099C1147.4 608.499 1148 608.999 1148 609.199Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.8 618.2C1145.7 618.3 1145.1 617.9 1144.6 617.2C1144.1 616.5 1143.7 615.9 1143.9 615.8C1144.1 615.7 1144.6 616.1 1145.1 616.8C1145.6 617.5 1146 618.1 1145.8 618.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.4 585.701C1145.5 585.801 1145.1 586.301 1144.5 586.601C1143.9 586.901 1143.3 586.901 1143.3 586.801C1143.3 586.701 1143.7 586.401 1144.3 586.101C1144.9 585.801 1145.3 585.501 1145.4 585.701Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.2 594C1153.2 594.2 1152.5 594.5 1151.5 594.7C1150.5 594.9 1149.7 594.7 1149.7 594.5C1149.7 594.3 1150.5 594.2 1151.4 594.1C1152.3 594 1153.1 593.8 1153.2 594Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.6 586.5C1151.7 586.7 1151 587.2 1149.9 587.5C1148.8 587.8 1148 587.8 1148 587.7C1148 587.6 1148.8 587.3 1149.7 586.9C1150.6 586.5 1151.5 586.3 1151.6 586.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.9 605.5C1154.9 605.7 1153.7 605.8 1152.2 605.5C1150.7 605.2 1149.6 604.7 1149.7 604.5C1150.6 604.5 1151.5 604.6 1152.3 604.8C1153.7 605.2 1154.9 605.3 1154.9 605.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 616.299C1151.9 616.399 1151 615.899 1150.1 614.999C1149.2 614.099 1148.7 613.199 1148.8 613.099C1148.9 612.999 1149.7 613.699 1150.5 614.599C1151.3 615.499 1152.1 616.199 1152 616.299Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1122.3 598.402C1122.3 598.602 1121.2 598.602 1120 598.502C1118.8 598.402 1117.7 598.202 1117.7 598.002C1117.7 597.802 1118.8 597.802 1120 597.902C1121.2 598.002 1122.3 598.202 1122.3 598.402Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1122.6 591.901C1122.5 592.101 1121.6 591.801 1120.6 591.301C1119.6 590.801 1118.8 590.301 1118.8 590.201C1118.8 590.101 1119.8 590.301 1120.8 590.801C1121.8 591.301 1122.7 591.701 1122.6 591.901Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1126 587C1125.9 587.1 1124.9 586.7 1123.8 585.8C1122.7 584.9 1122.1 584 1122.2 583.9C1122.3 583.8 1123.2 584.5 1124.2 585.3C1125.2 586.1 1126.1 586.9 1126 587Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1129.4 582.4C1129.2 582.5 1128.8 581.7 1128.3 580.7C1127.8 579.7 1127.6 578.8 1127.8 578.7C1128 578.6 1128.4 579.4 1128.9 580.4C1129.4 581.4 1129.5 582.4 1129.4 582.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1134.7 579.199C1134.5 579.299 1134 578.499 1133.7 577.299C1133.4 576.099 1133.3 575.199 1133.5 575.199C1133.7 575.199 1134 575.999 1134.3 577.099C1134.6 578.199 1134.8 579.099 1134.7 579.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1143.5 575.5C1143.7 575.6 1143.6 576.3 1143.3 577C1143 577.7 1142.7 578.4 1142.5 578.3C1142.3 578.2 1142.4 577.5 1142.7 576.7C1143 575.9 1143.4 575.5 1143.5 575.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1150.1 578.3C1150.2 578.4 1149.8 579 1149.2 579.6C1148.6 580.2 1148 580.6 1147.8 580.4C1147.6 580.2 1148.1 579.7 1148.7 579.1C1149.3 578.5 1150 578.2 1150.1 578.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1155.9 582.102C1156 582.202 1155.5 582.802 1154.7 583.302C1153.9 583.802 1153.3 584.102 1153.2 583.902C1153.1 583.702 1153.6 583.202 1154.3 582.702C1155 582.202 1155.8 581.902 1155.9 582.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1160 587.6C1160.1 587.8 1159.3 588.3 1158.2 588.7C1157.1 589.1 1156.2 589.4 1156.1 589.2C1156 589 1156.9 588.5 1157.9 588.1C1158.9 587.7 1159.9 587.5 1160 587.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1161.6 593.701C1161.6 593.901 1160.8 594.101 1159.8 594.201C1158.8 594.301 1157.9 594.301 1157.9 594.101C1157.9 593.901 1158.7 593.701 1159.7 593.601C1160.7 593.501 1161.6 593.501 1161.6 593.701Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1162.4 601.199C1162.3 601.399 1161.4 601.099 1160.4 600.699C1159.4 600.299 1158.6 599.799 1158.7 599.599C1158.8 599.399 1159.6 599.699 1160.7 600.099C1161.8 600.499 1162.5 600.999 1162.4 601.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1161.7 607.601C1161.6 607.801 1160.5 607.502 1159.4 606.702C1158.3 605.902 1157.6 605.002 1157.7 604.902C1157.8 604.802 1158.7 605.402 1159.8 606.202C1160.9 607.002 1161.8 607.401 1161.7 607.601Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1158.4 613.401C1158.3 613.501 1157.4 613.001 1156.6 612.101C1155.8 611.201 1155.3 610.301 1155.4 610.201C1155.5 610.101 1156.2 610.801 1157 611.701C1157.8 612.601 1158.5 613.301 1158.4 613.401Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1126.7 614.101C1126.8 614.301 1125.9 614.901 1124.6 615.501C1123.3 616.101 1122.3 616.501 1122.2 616.401C1122.1 616.301 1123 615.601 1124.3 615.001C1125.6 614.401 1126.6 614.001 1126.7 614.101Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1123.8 608.8C1123.9 609 1123.1 609.501 1122.1 609.901C1121.1 610.301 1120.3 610.601 1120.2 610.401C1120.1 610.201 1120.9 609.8 1121.9 609.3C1122.9 608.8 1123.7 608.7 1123.8 608.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1121.6 604.201C1121.6 604.401 1120.7 604.601 1119.5 604.801C1118.3 605.001 1117.4 605.001 1117.4 604.801C1117.4 604.601 1118.3 604.401 1119.4 604.201C1120.5 604.001 1121.6 604.001 1121.6 604.201Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1128.6 601.601C1128.7 601.801 1127.8 602.201 1126.6 602.301C1125.4 602.401 1124.4 602.201 1124.5 602.101C1124.6 602.001 1125.4 601.901 1126.6 601.701C1127.8 601.501 1128.6 601.401 1128.6 601.601Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1134.4 595.802C1134.4 596.002 1133.7 596.302 1132.8 596.402C1131.9 596.502 1131.1 596.302 1131.1 596.102C1131.1 595.902 1131.9 595.902 1132.8 595.802C1133.7 595.702 1134.4 595.702 1134.4 595.802Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1135.5 591.2C1135.4 591.4 1134.7 591.2 1133.8 590.9C1132.9 590.6 1132.2 590.2 1132.3 590.1C1132.4 590 1133.1 590.1 1134 590.4C1134.9 590.7 1135.6 591 1135.5 591.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1137.7 586.501C1137.6 586.601 1137 586.301 1136.7 585.601C1136.4 584.901 1136.3 584.301 1136.4 584.301C1136.5 584.301 1136.9 584.701 1137.2 585.301C1137.5 585.901 1137.8 586.401 1137.7 586.501Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1135.1 605.701C1135.1 605.901 1134.5 606.201 1133.6 606.401C1133.2 606.501 1132.8 606.601 1132.4 606.601L1132.3 606.201C1132.5 606.201 1132.7 606.201 1132.7 606.201C1132.7 606.201 1132.6 606.401 1132.5 606.501L1132.4 606.101C1132.8 605.901 1133.2 605.801 1133.6 605.701C1134.3 605.501 1135.1 605.501 1135.1 605.701Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1136.3 613.8C1136.4 614 1135.5 614.501 1134.4 614.901C1133.3 615.301 1132.3 615.601 1132.3 615.401C1132.3 615.201 1133.1 614.8 1134.2 614.3C1135.3 613.8 1136.2 613.7 1136.3 613.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1129.7 610.202C1129.8 610.402 1129.2 610.702 1128.4 611.002C1127.6 611.302 1127 611.302 1126.9 611.202C1126.8 611.102 1127.4 610.702 1128.2 610.402C1129 610.102 1129.7 610.002 1129.7 610.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1130.2 593.5C1130.2 593.7 1129.2 593.6 1128 593.2C1126.8 592.8 1126 592.2 1126.1 592.1C1126.2 592 1127.1 592.2 1128.2 592.6C1129.3 593 1130.3 593.4 1130.2 593.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1146.1 591.699C1146.2 591.799 1145.6 592.399 1144.9 592.899C1144.2 593.399 1143.4 593.699 1143.3 593.599C1143.2 593.499 1143.8 592.899 1144.5 592.399C1145.2 591.899 1146 591.599 1146.1 591.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1147 600.002C1147 600.202 1146.4 600.402 1145.7 600.602C1145 600.802 1144.3 600.802 1144.3 600.602C1144.3 600.402 1144.9 600.202 1145.6 600.002C1146.3 599.802 1146.9 599.802 1147 600.002Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1148 609.199C1147.9 609.399 1147.1 609.099 1146.1 608.699C1145.1 608.299 1144.4 607.799 1144.5 607.599C1144.6 607.399 1145.4 607.699 1146.4 608.099C1147.4 608.499 1148 608.999 1148 609.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1145.8 618.2C1145.7 618.3 1145.1 617.9 1144.6 617.2C1144.1 616.5 1143.7 615.9 1143.9 615.8C1144.1 615.7 1144.6 616.1 1145.1 616.8C1145.6 617.5 1146 618.1 1145.8 618.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1145.4 585.701C1145.5 585.801 1145.1 586.301 1144.5 586.601C1143.9 586.901 1143.3 586.901 1143.3 586.801C1143.3 586.701 1143.7 586.401 1144.3 586.101C1144.9 585.801 1145.3 585.501 1145.4 585.701Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1153.2 594C1153.2 594.2 1152.5 594.5 1151.5 594.7C1150.5 594.9 1149.7 594.7 1149.7 594.5C1149.7 594.3 1150.5 594.2 1151.4 594.1C1152.3 594 1153.1 593.8 1153.2 594Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1151.6 586.5C1151.7 586.7 1151 587.2 1149.9 587.5C1148.8 587.8 1148 587.8 1148 587.7C1148 587.6 1148.8 587.3 1149.7 586.9C1150.6 586.5 1151.5 586.3 1151.6 586.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1154.9 605.5C1154.9 605.7 1153.7 605.8 1152.2 605.5C1150.7 605.2 1149.6 604.7 1149.7 604.5C1150.6 604.5 1151.5 604.6 1152.3 604.8C1153.7 605.2 1154.9 605.3 1154.9 605.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1152 616.299C1151.9 616.399 1151 615.899 1150.1 614.999C1149.2 614.099 1148.7 613.199 1148.8 613.099C1148.9 612.999 1149.7 613.699 1150.5 614.599C1151.3 615.499 1152.1 616.199 1152 616.299Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1139.6 577.602H1138.7V620.202H1139.6V577.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.2 654.401H1127.6L1122.8 619.301H1157.9L1153.2 654.401Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.9 624.598H1119.9L1119.3 616.898H1161.5L1160.9 624.598Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1123.6 624.602H1157.2L1153.2 654.402L1149.1 654.102L1151.4 627.002L1123.8 626.602L1123.6 624.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1152.1 616.998L1150.9 624.598H1160.9L1161.5 616.898L1152.1 616.998Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1155.5 633.5H1125.1V634.1H1155.5V633.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1155.5 635.801H1125.1V636.401H1155.5V635.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.8 388.5H1184.4V1012.2H1259.7V430.4L1219.8 388.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1219.8 388.5H1184.4V1012.2H1259.7V430.4L1219.8 388.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 998.6L826.7 1000.1L803.3 983.4C799.4 980.6 799.1 976.4 799 971.6L798 953L766.1 953.1L768 998.6Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M776.5 977.101V976.801C776.3 974.801 777.7 973.001 779.7 972.701L798.8 970.001L798.6 966.301H767L767.8 997.401L793.4 994.501L784.9 991.201C779.2 988.801 777.1 983.401 776.5 977.101Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.8 1008.3V1007C847.8 1002.8 844.4 999.502 840.3 999.502H829.8C827.6 999.502 825.4 998.702 823.9 997.102L798 974.602L788.7 982.602C786.3 985.702 781.8 986.302 778.7 983.902C778.3 983.602 777.9 983.202 777.5 982.802C776.1 981.202 774.1 980.202 772 980.202H766.4V1007.8L847.8 1008.3Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.8 1008.3V1012.4H766.2V1007.8L847.8 1008.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.201 977.199L810.8 993.699C812.6 995.499 815.501 995.699 817.501 993.999L819.001 992.799L800.201 970.899C799.101 970.499 797.9 970.799 797.1 971.599L794.6 974.399C794 974.999 793.701 975.999 794.001 976.899L794.201 977.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.3 985L804.4 991.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.35px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.8 981L800.8 987.4",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.35px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.3 977.199L797.3 983.499",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.35px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867 998.6L918 1000L902.3 983.4C898.4 980.6 891.1 976.4 891 971.6L886 953L854.1 953.1L867 998.6Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M868.5 977.099V976.799C868.3 974.699 870.1 971.299 872 970.999L887.8 962.899L887.6 959.199L859 966.199L866.8 997.299L892.4 994.399L883.9 991.099C878.2 988.799 869.1 983.399 868.5 977.099Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.8 1008.3V1007C942.8 1002.8 939.4 999.502 935.3 999.502H924.8C922.6 999.502 920.4 998.702 918.9 997.102L893 974.602L883.7 982.602C881.3 985.702 876.8 986.302 873.7 983.902C873.3 983.602 872.9 983.202 872.5 982.802C871.1 981.202 869.1 980.202 867 980.202H861.4V1007.8L942.8 1008.3Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.8 1008.3V1012.4H861.2V1007.8L942.8 1008.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.6 979.499L906.8 994.199C908.8 995.799 911.7 995.699 913.5 993.899L914.9 992.499L894 972.598C892.9 972.298 891.7 972.698 891 973.598L888.8 976.699C888.2 977.399 888.1 978.399 888.5 979.199L888.6 979.499Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.5 985.398L900.3 992.398",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.35px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.6 981.801L896.2 989.001",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.35px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.7 978.398L892.4 985.398",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.35px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.7 966.798L858.7 975.798L816.7 828.798H685.8L667 776.998L715.8 772.898L834.1 778.598C843.6 778.298 847.9 783.898 851.3 793.198L891.7 966.798Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M876.1 971.298L858.7 975.798L816.9 828.798H685.8L667 776.998L715.8 772.898L796.8 777.898C813 777.998 816.8 777.898 823.1 788.898L876.1 971.298Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.9 968.3H763.7C758.7 894.9 752.1 844.2 753.9 828.8L652.4 827.8C635.2 827.8 621.2 815.9 621.2 800L619.2 775.9L685 775L781.4 779.9C781.8 779.9 782.1 779.9 782.5 779.9C795 780.4 804.8 790.2 805 801.8L801.9 968.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M765.6 815.398C763.4 814.698 664.1 813.398 664.1 813.398C659 812.998 650.8 809.098 646.4 805.198C637 796.898 634.6 787.198 643.1 778.098L645.1 775.898H619.3L621.3 799.998C621.3 815.898 635.3 827.798 652.5 827.798L754 828.798C752.5 857.498 759.4 907.898 763.6 968.898H776.8C776.7 968.898 767 816.598 765.6 815.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.9 658.099L720.8 691.699L755.7 684.499L743.2 637.799C741.4 632.499 737.6 628.099 732.7 625.499L718.2 620.699L713.9 658.099Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.9 767.201C718.8 772.601 714.4 776.801 709 776.701C709 776.701 709 776.701 708.9 776.701C678 775.901 634.3 775.401 619 776.901C616.6 777.101 614.4 775.401 614.2 772.901C614.2 772.801 614.2 772.601 614.2 772.501L626 618.001L657.9 611.801L698.3 612.701L732.8 625.701L720.3 706.901L716.3 752.001L718.9 767.201Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.4 736.301V736.401V736.301Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      strokeWidth: "0.9px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693 727.7L704.7 727.5L726.4 726C728.3 726.1 730.1 726.9 731.4 728.2L744.5 740.4C745.3 741.2 745.4 742.5 744.7 743.3C744 744.2 742.7 744.3 741.8 743.6L729.3 734.1L737.3 744C738 744.9 737.9 746.2 737 746.9C736.8 747.1 736.6 747.2 736.4 747.2C735.7 747.5 734.8 747.3 734.3 746.7L723.5 735.7L731.7 744.1C732.4 744.9 732.4 746.1 731.7 746.8C731.5 747 731.3 747.1 731 747.2C730.4 747.5 729.7 747.4 729.1 747.1L717.6 738.3L725.4 744.3C726.1 744.8 726.3 745.9 725.8 746.6C725.7 746.7 725.6 746.9 725.4 747C724.9 747.3 724.3 747.4 723.7 747.2L713.2 742.6C712.2 742.1 711 742.1 710 742.6L705.9 744.5C703.4 745.6 700 745.3 696.4 745.2L687.9 744.6C689.3 738.8 693 727.7 693 727.7Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M715.3 741.199C717.7 742.499 721.7 744.599 723.1 745.499C725.1 746.699 725.7 745.199 725.7 745.199C725.9 745.899 725.6 746.599 725 746.999C724.5 747.299 723.9 747.399 723.4 747.199L712.9 742.499C711.9 741.999 710.7 741.999 709.7 742.499L711.8 741.299C712.8 740.699 714.2 740.699 715.3 741.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M724.7 743.5C724.6 743.5 724.5 743.5 724.5 743.4L717.3 737.9C717.1 737.8 717.1 737.6 717.2 737.4C717.3 737.2 717.5 737.2 717.7 737.3L724.9 742.8C725 743 725.1 743.2 725 743.3C724.9 743.4 724.8 743.5 724.7 743.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M730.8 743.1C730.7 743.1 730.6 743.1 730.6 743L722.9 735.2C722.8 735.1 722.8 734.8 722.9 734.7C723 734.6 723.2 734.6 723.4 734.7L731.1 742.5C731.2 742.6 731.2 742.9 731.1 743C731 743.1 730.9 743.2 730.8 743.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M692.2 741.102L699 742.402C699 742.402 705.4 743.902 709.7 742.402C709.7 742.402 705.4 745.902 697.5 745.002L691.1 744.502L692.2 741.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M693 722.8L626 710.2L629.8 660.8C629.8 660.3 629.4 660 628.9 660C628.4 660 628.1 660.4 628.1 660.9L619.6 713.9L693 725.7V722.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M614.3 772.501L617 742.301L636 744.001L635 776.001C629.7 775.901 624.4 776.201 619.1 776.901C616.7 777.101 614.5 775.401 614.3 772.901C614.3 772.701 614.3 772.601 614.3 772.501Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M685.4 635L681.1 748.1C681.1 748.1 681.7 766.1 676.8 775.1",
    stroke: "black",
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693 725L619.2 713.2L633.8 618L623.6 621.5C608 626.1 600 636 596.9 651.3L584.3 720.4C583.2 726.1 584.2 732 587.3 737L588 738C592.4 744.1 599.5 747.6 607 747.5L691 746.1L693 725Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 711L635.1 616.5L623.3 618.7C620.4 619.5 617.5 620.6 614.9 622C603.6 627.9 598.1 639.9 596.1 654L587.1 704.9L620 711Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M723.2 691.799L725.5 666.199L726.9 666.399L728 689.999L723.2 691.799Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M590.5 733.202C596 738.602 603.3 741.702 611 741.802L690.8 742.802L691 747.202L608.7 747.702C596.4 747.602 584.1 739.102 584.6 726.202C584.6 725.802 584.5 725.402 584.5 725.002L584.2 720.102C584.4 725.502 587.1 729.902 590.5 733.202Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 569C705 569 672.5 543.1 668.1 569.8L666.8 576.7L660.4 610.6C660.3 611.6 660.5 612.6 661.1 613.4L683.8 628C684.4 628.5 685.2 628.5 685.8 628.1L698.2 616.6C699.3 615.8 700 614.6 700 613.2V595C700.7 593 701.2 591 701.4 588.9C702.9 578.4 705 569 705 569Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.9 571.002C720.467 571.002 726.6 564.868 726.6 557.302C726.6 549.735 720.467 543.602 712.9 543.602C705.334 543.602 699.2 549.735 699.2 557.302C699.2 564.868 705.334 571.002 712.9 571.002Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.9 550.099C716.9 550.099 717.4 606.199 689.2 603.499C664.8 601.199 670.7 563.799 670.7 563.799L677.3 540.199L716.9 550.099Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.8 525.7C705.4 524 698.3 525.6 693.6 529.4C691.2 531.2 688 531.7 685.3 530.5C684.4 530.3 683.6 530.1 682.7 530C658.7 526.2 653.9 562.3 675.9 564.4C680.6 564.8 685.3 562.6 688.8 558C691.1 554.9 695.4 553.9 698.8 555.8C700.9 556.9 703 557.7 705.3 558.2C716.6 560.8 727.5 555.6 729.5 546.7C731.5 537.8 724.1 528.3 712.8 525.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.818 533.737C699.622 530.238 696.653 526.569 692.185 525.542C687.718 524.515 683.444 526.518 682.639 530.017C681.835 533.515 684.804 537.184 689.272 538.212C693.739 539.239 698.013 537.235 698.818 533.737Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M667.5 573.699C668.7 574.099 670 574.099 671.2 573.699L666 578.799L667.5 573.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M700.1 601.701L700 601.801C695.3 604.201 689.8 604.501 684.9 602.801C681.2 601.401 678.1 598.901 675.9 595.601C675.7 595.301 675.4 595.201 675.1 595.401C674.8 595.601 674.7 595.901 674.9 596.201C677.7 600.401 682 603.401 687 604.501C690.6 607.601 695.2 609.401 700 609.501H700.1V601.701Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M693 594.201C693 594.301 693 594.301 693 594.201L690 593.501C689.6 593.401 689.4 593.001 689.5 592.701C689.6 592.301 689.9 592.101 690.3 592.201C690.3 592.201 690.3 592.201 690.4 592.201L693.4 592.801C693.8 592.901 694 593.201 693.9 593.601C693.7 594.101 693.4 594.301 693 594.201Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.8 576.099C692.015 576.099 693 575.114 693 573.899C693 572.684 692.015 571.699 690.8 571.699C689.585 571.699 688.6 572.684 688.6 573.899C688.6 575.114 689.585 576.099 690.8 576.099Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.9 573.898C692.177 573.898 692.4 573.675 692.4 573.398C692.4 573.122 692.177 572.898 691.9 572.898C691.624 572.898 691.4 573.122 691.4 573.398C691.4 573.675 691.624 573.898 691.9 573.898Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.1 580.201C709.315 580.201 710.3 579.216 710.3 578.001C710.3 576.786 709.315 575.801 708.1 575.801C706.885 575.801 705.9 576.786 705.9 578.001C705.9 579.216 706.885 580.201 708.1 580.201Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.2 578C709.476 578 709.7 577.776 709.7 577.5C709.7 577.224 709.476 577 709.2 577C708.924 577 708.7 577.224 708.7 577.5C708.7 577.776 708.924 578 709.2 578Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M698.5 585.298L695.6 584.798C695.2 584.698 695 584.398 695 583.998C695.1 583.698 695.4 583.398 695.8 583.398L698.7 583.898C699.4 583.998 700.1 583.498 700.2 582.798C700.3 582.098 699.8 581.398 699.1 581.298C698.8 581.198 698.5 580.898 698.5 580.498C698.5 580.098 698.9 579.998 699.3 579.898C700.7 580.198 701.7 581.498 701.5 582.898C701.4 584.398 700 585.498 698.5 585.298Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.7 566.999C716 567.599 715.7 568.599 715.9 569.499C716.3 570.699 716.5 570.699 718 572.299C720 574.599 721.9 577.099 723.6 579.599C723.6 579.599 724.4 593.699 726.3 596.599C728 599.199 730.1 598.999 730.1 598.999L732.9 610.099L749.8 605.599C749.8 605.599 746.2 595.599 744.9 592.499C743.6 589.299 737.7 569.299 737.7 569.299L733 559.099L728.8 555.199C728.4 554.799 727.8 554.799 727.4 555.099C727.2 555.299 727.1 555.599 727.1 555.899C727.1 556.599 727.3 557.199 727.7 557.699C728.9 559.599 730 561.599 730.9 563.699L720.4 554.999C719.6 554.399 718.5 554.499 717.9 555.199C717.6 555.599 717.4 556.099 717.5 556.599C717.5 556.899 717.6 557.099 717.7 557.399C716.6 558.799 716.7 560.799 718.1 561.899C720.8 564.299 725.4 572.599 724.7 572.799L717 566.599L716.7 566.999Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M730.8 563.6L734.2 567.7L729.8 561.5L730.8 563.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M717.6 557.5L725.2 564C725.2 564 729.1 568.9 730.2 571.7",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M689.2 589.001C689.8 588.901 690.3 588.801 690.8 588.801H691.3C695.3 588.601 696.8 591.001 697.3 592.101V592.201C697.4 592.501 697.2 592.901 697 593.101L696.9 593.201H696.8H696.6C696.3 593.201 696.1 593.101 695.9 592.901L695.8 592.801C695.4 591.801 694 589.701 689.7 590.601C689.3 590.701 688.8 590.501 688.7 590.101C688.6 589.701 688.8 589.201 689.2 589.001Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.9 564.402C675.9 564.402 673.5 573.202 672.2 569.402V563.102L675.9 564.402Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M731.1 625.002L734.8 656.202L729.1 655.502L729.2 624.102L731.1 625.002Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M619.2 713L613 712.2L620 709L619.2 713Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M680.5 723.5L677.5 746.5",
    stroke: "black",
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M684 744.5C684.828 744.5 685.5 743.828 685.5 743C685.5 742.172 684.828 741.5 684 741.5C683.172 741.5 682.5 742.172 682.5 743C682.5 743.828 683.172 744.5 684 744.5Z",
    stroke: "black",
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.8 520.801H675.8V540.901H676.8V520.801Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.7 530.102H680.7V544.502H681.7V530.102Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.2 525.699H670.2V545.799H671.2V525.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.3 527.301H686.3V547.401H687.3V527.301Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.2 600.9L734.8 656.2L763.4 655.3L749.3 597L728.2 600.9Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.8 606.699L655.1 612.299L670.7 640.499L684.7 628.099L660.8 606.699Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.2 614.698L693.7 634.998L684.7 628.098L699.8 610.898L703.2 614.698Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M653.1 612.801L670.7 640.101L681.3 630.301L684.4 635.001L681.3 628.101L670.7 636.501L655.1 612.301L653.1 612.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M703.2 614.699L697.7 636.999L688.7 628.699L685.4 634.999L689.1 630.299L698.3 639.399L703.9 614.999L703.2 614.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M731.2 611.298L750.7 608.398",
    stroke: "black",
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M747 605.5C747.828 605.5 748.5 604.828 748.5 604C748.5 603.172 747.828 602.5 747 602.5C746.172 602.5 745.5 603.172 745.5 604C745.5 604.828 746.172 605.5 747 605.5Z",
    stroke: "black",
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 565.101C689.3 564.701 691 565.401 693.2 565.701C695.4 566.001 697.2 565.901 697.4 566.501C697.5 566.701 697 567.101 696.2 567.401C694 568.101 691.7 567.701 689.9 566.401C689.2 565.801 688.9 565.301 689 565.101Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714 573.799C714 573.299 712.2 572.799 710.3 571.699C708.4 570.599 707 569.399 706.6 569.699C706.4 569.899 706.5 570.399 707 571.099C707.6 571.999 708.501 572.799 709.401 573.299C710.401 573.899 711.5 574.199 712.6 574.199C713.5 574.199 714 573.999 714 573.799Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.8 570.1L670.8 558L678.4 575L671 588L665.8 570.1ZM670.6 560.7L667 570.3L671.3 585.3L677.2 575L670.6 560.7Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.5 572.801C677.5 572.801 693 582.801 712.4 584.301C712.4 584.301 706.7 601.901 693 604.601C693 604.601 676.2 605.601 670.2 586.501C670.2 586.501 675.7 579.701 677.5 572.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M672.2 583.798C674.5 580.498 676.4 576.798 677.5 572.898C677.5 572.898 693 582.898 712.4 584.398C712.4 584.398 709.4 593.398 702.7 599.598C702.8 599.398 683.2 603.398 672.2 583.798Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M712.5 584.3L709.5 590.9C696.9 591.7 684.5 587.3 675.2 578.8C676.1 577.1 676.8 575.4 677.4 573.6L677.7 573C678.7 573.5 693.7 582.8 712.5 584.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M672.2 559.798C671.9 557.098 669.5 554.998 666.7 555.298C666.4 555.298 666.1 555.398 665.8 555.498C659.2 556.698 657.4 570.498 667.3 573.598C672.5 575.298 672.1 571.898 672.2 567.598V559.798Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M664.8 558.9C665.8 558.4 666.9 558.4 667.9 558.8C668.8 559.3 669.5 560.1 669.7 561.2C670.1 562.5 670.1 563.8 669.8 565.1L669.6 566.3C669.6 566.6 669.3 566.9 668.9 566.9C668.6 566.9 668.3 566.6 668.3 566.2V566.1L668.5 564.9C668.7 563.8 668.7 562.7 668.4 561.7C668.3 560.5 667.2 559.7 666 559.8C665.7 559.8 665.4 559.9 665.2 560.1C664.9 560.2 664.5 560 664.4 559.7C664.3 559.5 664.5 559.1 664.8 558.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979 1013V790.302V773.602H958.5V1013H979Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.7 760.301H499.8V777.001H978.7V760.301Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.3 748H476V763.9H1003.3V748Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M669 748H476.2V763.9H669V748Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.1 773.602H646.6V1013H667.1V773.602Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.3 773.602H499.8V1013H520.3V773.602Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M667.1 784H657.1V1013H667.1V784Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M520.3 843H510.3V1012.9H520.3V843Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M979 781.801H969V1013H979V781.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M978.8 764H500.3V768.7H978.8V764Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.4 743.801H728.5C729.1 743.801 729.6 744.301 729.6 744.901V746.701C729.6 747.301 729.1 747.801 728.5 747.801H657.4C656.8 747.801 656.3 747.301 656.3 746.701V744.901C656.3 744.301 656.7 743.801 657.4 743.801C657.3 743.801 657.3 743.801 657.4 743.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.2 744.102H829.2C829.8 744.102 830.3 744.602 830.3 745.202V747.002C830.3 747.602 829.8 748.102 829.2 748.102H705.2C704.6 748.102 704.1 747.602 704.1 747.002V745.202C704.2 744.602 704.7 744.202 705.2 744.102Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M705.2 744.102H829.2C829.8 744.102 830.3 744.602 830.3 745.202V747.002C830.3 747.602 829.8 748.102 829.2 748.102H705.2C704.6 748.102 704.1 747.602 704.1 747.002V745.202C704.2 744.602 704.7 744.202 705.2 744.102Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.8 744.501H701.5C701.3 744.501 701.2 744.401 701.1 744.201C701.1 744.001 701.2 743.801 701.4 743.801H827.6C827.8 743.801 828 743.901 828 744.101C828.1 744.401 828 744.501 827.8 744.501Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.1 743.8H723.8C725.3 743.8 726.5 742.8 726.8 741.3L742.5 659C742.8 657.4 741.7 655.8 740.1 655.5C739.9 655.5 739.7 655.5 739.5 655.5H720.8C719.3 655.5 718.1 656.5 717.8 658L702.1 740.3C701.8 741.9 702.9 743.5 704.5 743.8C704.7 743.8 704.9 743.8 705.1 743.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.7 743.8H827.7C829.1 743.8 830.4 742.8 830.7 741.3L846.4 659C846.7 657.4 845.6 655.8 844 655.5C843.8 655.5 843.6 655.5 843.4 655.5H723.5C722 655.5 720.8 656.5 720.5 658L704.8 740.3C704.5 741.9 705.5 743.4 707 743.8C707.3 743.8 707.5 743.8 707.7 743.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M707.7 743.8H827.7C829.1 743.8 830.4 742.8 830.7 741.3L846.4 659C846.7 657.4 845.6 655.8 844 655.5C843.8 655.5 843.6 655.5 843.4 655.5H723.5C722 655.5 720.8 656.5 720.5 658L704.8 740.3C704.5 741.9 705.5 743.4 707 743.8C707.3 743.8 707.5 743.8 707.7 743.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M780.7 699.899C779.8 701.999 780.8 703.799 782.9 703.799H783.3C780.8 706.499 777.1 708.399 773.9 708.299C769.5 708.199 767.4 704.599 769.4 700.099C771.4 695.599 776.6 692.199 781 692.299C783.8 692.399 785.7 693.799 786.2 696.099C783.8 696.399 781.7 697.799 780.7 699.899Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 855H409.6V873.7H534V855Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M534 855H467.6V873.7H534V855Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M424.1 864.199H409.6V864.599H424.1V864.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M479.1 864.199H464.6V864.599H479.1V864.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M499.3 858.398H459.3V858.798H499.3V858.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M435.2 869.199H409.6V869.599H435.2V869.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 873H425.6V891.7H550V873Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M550 873H425.6V891.7H550V873Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 873H483.6V891.7H550V873Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M550 873H483.6V891.7H550V873Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M440.1 882.199H425.6V882.599H440.1V882.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M511 882.199H464.7V882.599H511V882.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M534 876.398H456.5V876.798H534V876.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M539 885.398H461.5V885.798H539V885.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M451.2 887.199H425.6V887.599H451.2V887.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 836H431.6V854.7H556V836Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M556 836H431.6V854.7H556V836Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 836H489.6V854.7H556V836Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M556 836H489.6V854.7H556V836Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M446.1 845.199H431.6V845.599H446.1V845.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M517 845.199H470.7V845.599H517V845.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M540 839.398H462.5V839.798H540V839.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M545 848.398H467.5V848.798H545V848.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M457.2 850.199H431.6V850.599H457.2V850.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 674H496.6V692.7H621V674Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M621 674H554.6V692.7H621V674Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M511.1 683.199H496.6V683.599H511.1V683.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M566.1 683.199H551.6V683.599H566.1V683.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M586.3 677.398H546.3V677.798H586.3V677.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M522.2 688.199H496.6V688.599H522.2V688.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 692H512.6V710.7H637V692Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M637 692H512.6V710.7H637V692Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 692H570.6V710.7H637V692Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M637 692H570.6V710.7H637V692Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M527.1 701.199H512.6V701.599H527.1V701.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M598 701.199H551.7V701.599H598V701.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M621 695.398H543.5V695.798H621V695.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M626 704.398H548.5V704.798H626V704.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M538.2 706.199H512.6V706.599H538.2V706.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 729H512.6V747.7H637V729Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M637 729H512.6V747.7H637V729Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 729H570.6V747.7H637V729Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M637 729H570.6V747.7H637V729Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M527.1 738.199H512.6V738.599H527.1V738.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M598 738.199H551.7V738.599H598V738.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M621 732.398H543.5V732.798H621V732.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M626 741.398H548.5V741.798H626V741.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M538.2 743.199H512.6V743.599H538.2V743.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 711H495.6V729.7H620V711Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M620 711H553.6V729.7H620V711Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M510.1 720.199H495.6V720.599H510.1V720.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M565.1 720.199H550.6V720.599H565.1V720.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M585.3 714.398H545.3V714.798H585.3V714.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M521.2 725.199H495.6V725.599H521.2V725.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.6 729.199H926V746.599H976.6V729.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.7 728.199H845.8V747.799H924.7V728.199Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M924.7 728.199H845.8V747.799H924.7V728.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.1 732H854.2V744.1H896.1V732Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.4 732.601V743.401H855V732.601H895.4ZM896.9 731.301H853.4V744.701H896.9V731.301Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.6 732.602H856.3V743.402H863.6V732.602Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.2 732.602H887.5V743.402H890.2V732.602Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.6 742.098C908.3 742.098 906.5 740.298 906.5 737.998C906.5 735.698 908.3 733.898 910.6 733.898C912.9 733.898 914.7 735.698 914.7 737.998C914.7 740.298 912.9 742.098 910.6 742.098Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M910.6 734.501C912.6 734.501 914.1 736.101 914.1 738.101C914.1 740.101 912.5 741.601 910.5 741.601C908.6 741.601 907 740.001 907 738.101C907 736.001 908.6 734.501 910.6 734.501ZM910.6 733.301C908 733.301 905.9 735.401 905.9 738.001C905.9 740.601 908 742.701 910.6 742.701C913.2 742.701 915.3 740.601 915.3 738.001C915.3 735.401 913.2 733.301 910.6 733.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.7 746.399H976H926V729.599H976.5H977.7H979.2V728.199H924.5V747.799H979.2V746.399H977.7Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 730.5H926V731.3H976.6V730.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 732.102H926V732.902H976.6V732.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 733.699H926V734.499H976.6V733.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 735.199H926V735.999H976.6V735.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 736.801H926V737.601H976.6V736.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 738.301H926V739.101H976.6V738.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 739.898H926V740.698H976.6V739.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 741.398H926V742.198H976.6V741.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 743H926V743.8H976.6V743Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M976.6 744.5H926V745.3H976.6V744.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 690.699H922.4V708.099H973V690.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.1 689.602H842.2V709.202H921.1V689.602Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M921.1 689.602H842.2V709.202H921.1V689.602Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.6 693.398H850.7V705.498H892.6V693.398Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.8 693.999V704.799H851.4V693.999H891.8ZM893.4 692.699H849.9V706.099H893.4V692.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 694H852.7V704.8H860V694Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.6 694H883.9V704.8H886.6V694Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907 703.501C904.7 703.501 902.9 701.701 902.9 699.401C902.9 697.101 904.7 695.301 907 695.301C909.3 695.301 911.1 697.101 911.1 699.401C911.1 701.701 909.3 703.501 907 703.501Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M907 695.899C909 695.899 910.6 697.499 910.6 699.399C910.6 701.399 909 702.999 907.1 702.999C905.1 702.999 903.5 701.399 903.5 699.499C903.5 697.499 905 695.899 907 695.899ZM907 694.699C904.4 694.699 902.3 696.799 902.3 699.399C902.3 701.999 904.4 704.099 907 704.099C909.6 704.099 911.7 701.999 911.7 699.399C911.7 696.799 909.6 694.699 907 694.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.2 707.802H972.5H922.4V691.002H972.9H974.2H975.7V689.602H920.9V709.202H975.7V707.802H974.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 692H922.4V692.8H973V692Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 693.5H922.4V694.3H973V693.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 695.102H922.4V695.902H973V695.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 696.602H922.4V697.402H973V696.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 698.199H922.4V698.999H973V698.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 699.699H922.4V700.499H973V699.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 701.301H922.4V702.101H973V701.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 702.801H922.4V703.601H973V702.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 704.398H922.4V705.198H973V704.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M973 706H922.4V706.8H973V706Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.4 710H934.8V727.4H985.4V710Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.4 709H854.5V728.6H933.4V709Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.9 712.699H863V724.799H904.9V712.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.2 713.402V724.202H863.8V713.402H904.2ZM905.7 712.102H862.2V725.502H905.7V712.102Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.4 713.398H865.1V724.198H872.4V713.398Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.9 713.398H896.2V724.198H898.9V713.398Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M919.4 722.899C917.1 722.899 915.3 721.099 915.3 718.799C915.3 716.499 917.1 714.699 919.4 714.699C921.7 714.699 923.5 716.499 923.5 718.799C923.5 721.099 921.7 722.899 919.4 722.899Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M919.4 715.202C921.4 715.202 923 716.802 923 718.702C923 720.702 921.4 722.302 919.5 722.302C917.5 722.302 915.9 720.702 915.9 718.802C915.8 716.802 917.4 715.202 919.4 715.202ZM919.4 714.102C916.8 714.102 914.7 716.202 914.7 718.802C914.7 721.402 916.8 723.502 919.4 723.502C922 723.502 924.1 721.402 924.1 718.802C924.1 716.202 922 714.102 919.4 714.102Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.5 727.2H984.8H934.8V710.3H985.3H986.5H988V709H933.2V728.6H988V727.2H986.5Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M986.5 727.2H984.8H934.8V710.3H985.3H986.5H988V709H933.2V728.6H988V727.2H986.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 711.301H934.8V712.101H985.4V711.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 712.898H934.8V713.698H985.4V712.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 714.398H934.8V715.198H985.4V714.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 716H934.8V716.8H985.4V716Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 717.5H934.8V718.3H985.4V717.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 719.102H934.8V719.902H985.4V719.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 720.602H934.8V721.402H985.4V720.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 722.199H934.8V722.999H985.4V722.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 723.801H934.8V724.601H985.4V723.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M985.4 725.301H934.8V726.101H985.4V725.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.4 671H939.8V688.4H990.4V671Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.4 670H859.5V689.6H938.4V670Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.9 673.699H868V685.799H909.9V673.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.2 674.402V685.202H868.8V674.402H909.2ZM910.7 673.102H867.2V686.502H910.7V673.102Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.4 674.398H870.1V685.198H877.4V674.398Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.9 674.398H901.2V685.198H903.9V674.398Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M924.4 683.899C922.1 683.899 920.3 682.099 920.3 679.799C920.3 677.499 922.1 675.699 924.4 675.699C926.7 675.699 928.5 677.499 928.5 679.799C928.5 682.099 926.7 683.899 924.4 683.899Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M924.4 676.202C926.4 676.202 928 677.802 928 679.702C928 681.702 926.4 683.302 924.5 683.302C922.5 683.302 920.9 681.702 920.9 679.802C920.8 677.802 922.4 676.202 924.4 676.202ZM924.4 675.102C921.8 675.102 919.7 677.202 919.7 679.802C919.7 682.402 921.8 684.502 924.4 684.502C927 684.502 929.1 682.402 929.1 679.802C929.1 677.202 927 675.102 924.4 675.102Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.5 688.2H989.8H939.8V671.3H990.3H991.5H993V670H938.2V689.6H993V688.2H991.5Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M991.5 688.2H989.8H939.8V671.3H990.3H991.5H993V670H938.2V689.6H993V688.2H991.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 672.301H939.8V673.101H990.4V672.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 673.898H939.8V674.698H990.4V673.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 675.398H939.8V676.198H990.4V675.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 677H939.8V677.8H990.4V677Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 678.5H939.8V679.3H990.4V678.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 680.102H939.8V680.902H990.4V680.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 681.602H939.8V682.402H990.4V681.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 683.199H939.8V683.999H990.4V683.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 684.801H939.8V685.601H990.4V684.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M990.4 686.301H939.8V687.101H990.4V686.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 907.801H396.9V1012.6H585V907.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M585 907.801H396.9V1012.6H585V907.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.2 908.801H506V1012H585.2V908.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M585.2 908.801H506V1012H585.2V908.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M436.1 919H465.2C467 919 468.5 920.5 468.5 922.3V922.7C468.5 924.5 467 926 465.2 926H436.1C434.3 926 432.8 924.5 432.8 922.7V922.3C432.8 920.4 434.3 919 436.1 919Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 891H391.4V914.1H589V891Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M589 891H391.4V914.1H589V891Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M588.8 891H509.3V914.1H588.8V891Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 948H419V979H485V948Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345 1015.6H312.2C311.4 1015.7 310.6 1015.1 310.5 1014.3C310.4 1013.5 311 1012.7 311.8 1012.6C311.9 1012.6 312 1012.6 312.1 1012.6H1345C1345.8 1012.5 1346.6 1013.1 1346.7 1013.9C1346.8 1014.7 1346.2 1015.5 1345.4 1015.6C1345.2 1015.6 1345.1 1015.6 1345 1015.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1345 1015.6H312.2C311.4 1015.7 310.6 1015.1 310.5 1014.3C310.4 1013.5 311 1012.7 311.8 1012.6C311.9 1012.6 312 1012.6 312.1 1012.6H1345C1345.8 1012.5 1346.6 1013.1 1346.7 1013.9C1346.8 1014.7 1346.2 1015.5 1345.4 1015.6C1345.2 1015.6 1345.1 1015.6 1345 1015.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2 553.702L290.5 622.002L556.3 626.002V394.102H370.1L290.2 553.702Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M290.2 553.702L290.5 622.002L556.3 626.002V394.102H370.1L290.2 553.702Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.6 399.202L367.6 399.102L326.4 481.302L393.6 399.202Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.3 540.301L485.2 620.901L430.7 620.601L551.3 484.801V540.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.3 414.6L367.6 620.6L291 621.4L290.2 609.4L473 399L551.3 399.4V414.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2 399.398H424V620.598H427.2V399.398Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.2 399.398H424V620.598H427.2V399.398Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.1 553.9V620.6H293.3V547.5L290.1 553.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.1 553.9V620.6H293.3V547.5L290.1 553.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.6 502.199H546.8V399.199H547.7V502.199H547.9C548.6 502.199 549.3 502.799 549.3 503.499V517.899C549.3 518.599 548.7 519.299 548 519.299H546.8C546.1 519.299 545.4 518.699 545.4 517.999V503.599C545.4 502.899 545.9 502.299 546.6 502.199C546.5 502.199 546.5 502.199 546.6 502.199Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.2 437.902H551.3V434.102H350.1L348.2 437.902Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4 431.401H551.3V427.801H353.3L351.4 431.401Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.7 425.001H551.3V421.301H356.5L354.7 425.001Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.9 418.501H551.3V414.801H359.7L357.9 418.501Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1 411.998H551.3V408.398H363L361.1 411.998Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.4 405.598H551.3V401.898H366.2L364.4 405.598Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.2 437.902H551.3V434.102H350.1L348.2 437.902Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.4 431.401H551.3V427.801H353.3L351.4 431.401Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.7 425.001H551.3V421.301H356.5L354.7 425.001Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M357.9 418.501H551.3V414.801H359.7L357.9 418.501Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M361.1 411.998H551.3V408.398H363L361.1 411.998Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.4 405.598H551.3V401.898H366.2L364.4 405.598Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.3 401.898H551.3V405.598H549.3V401.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.3 408.398H551.3V411.998H549.3V408.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.3 414.801H551.3V418.501H549.3V414.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.3 421.301H551.3V425.001H549.3V421.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.3 427.699H551.3V431.399H549.3V427.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.3 434.102H551.3V437.802H549.3V434.102Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M417.1 405.602H427.2V407.202H417.1V405.602Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M417.1 412H427.2V413.6H417.1V412Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M417.1 418.5H427.2V420.1H417.1V418.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M417.1 425H427.2V426.6H417.1V425Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M417.1 431.398H427.2V432.998H417.1V431.398Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M417.1 437.898H427.2V439.498H417.1V437.898Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.1 389H560.9V631H564.1V389Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M564.1 389H560.9V631H564.1V389Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.4 389H372.7L367.7 399.1H413.7V621H290.8L290.6 552.9L280.1 573.9V631H561.4V389V389ZM551.3 620.9H423.6V399.1H551.2V620.9H551.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M561.4 389H372.7L367.7 399.1H413.7V621H290.8L290.6 552.9L280.1 573.9V631H561.4V389V389ZM551.3 620.9H423.6V399.1H551.2V620.9H551.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicDashboardStudyMaterials1);
export default __webpack_public_path__ + "static/media/BasicDashboardStudyMaterials1.fd49a209869f57dc71abbdc49a0d1ad4.svg";
export { ForwardRef as ReactComponent };